import React, { useState } from "react";
import leftPng from "../../../../content/images/left.png";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import CatalogusGebruikers from "./modals/CatalogusGebruikers";
import Attachments from "./modals/Attachments";
import $ from "jquery";
import CommonAttachments from "../../../common/attachment/Attachment";

const Detail = () => {
  const [gebruikers, handlegebruikers] = useState(false);
  const [media, setMedia] = useState(null);

  const handleModalGebruikers = async () => {
    let result = await omnimap.GetRelationAction(
      window.$catalog_work_plans_selectedRow.identification,
      1,
      30,
      window.$catalog_management_units_token
    );
    await handlegebruikers(result);

    $("#catalogus-gebruikers").modal("show");
  };

  const handleModalAttachments = async () => {
    const spin = $("#cover-spin");
    spin.show(0);
    let result = await omnimap.GetMediaListAction(
      { path: "" },
      window.$catalog_work_plans_selectedRow.identification,
      window.$catalog_management_units_token
    );
    await setMedia(result);
    spin.hide(0);

    $("#wp-catalogus-attachments").modal("show");
  };

  return (
    <div id="detailSide" className="d-none">
      <div className="detail-title">Werkplannen in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Werkplannen
          </a>
        </div>
        <div className="float-right mt-0">
          <a id="edit-button" className="button bewerken">
            Bewerken
          </a>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam werkplan</div>
            <div className="box-title-2-active" id="d-algemeen-naam" />
            <span
              className="tooltiptext detail"
              id="naam-tooltip"
              id="d-algemeen-naam-tooltip"
            ></span>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Code</div>
            <div className="box-title-2" id="d-algemeen-code" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Omschrijving</div>
            <div className="box-title-2" id="d-algemeen-omschrijving" />
            <span
              className="tooltiptext detail"
              id="naam-tooltip"
              id="d-algemeen-omschrijving-tooltip"
            ></span>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-2 text-center">
          <div className="box-detail">
            <div className="box-title-1">Bijlage(n)</div>
            <a role="button" onClick={() => handleModalAttachments()}>
              <div className="box-title-2 bijlage-ico" id="d-bijlage" />
            </a>
          </div>
        </div>
        <div className="col-lg-2 text-center">
          <div className="box-detail">
            <div className="box-title-1">Gebruikers</div>
            <a role="button" onClick={() => handleModalGebruikers()}>
              <div className="box-title-2 gebruikers-ico" id="d-gebruikers" />
            </a>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Status</div>
            <div className="box-title-2" id="d-algemeen-status" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Actief</div>
            <label className="switch">
              <input id="algemeen_active" type="checkbox" disabled />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
      </div>
      <CatalogusGebruikers gebruikers={gebruikers} />

      <CommonAttachments
          media={media}
          setMedia={setMedia}
          rowId={window.$catalog_work_plans_selectedRow.identification}
          contextToReload={window.$catalog_work_plans_context}
      />
    </div>
  );
};

export default Detail;
